/**
 * Technique Column Definitions for SelectionTable
 *
 * Defines 2 columns for MITRE ATT&CK technique selection:
 * 1. Category - MITRE tactic/category (e.g., "Reconnaissance", "Execution")
 * 2. TTP Name - Technique name with ID as metadata
 */

import type { ColumnDef, SortingState } from '@tanstack/react-table';

import { OverflowText } from '@/components/OverflowText';
import type { SearchableListItem } from '@/sections/attacks/attackPaths/components/wizards/hooks';

import { NameCell } from './shared';

/**
 * Column definitions for technique selection table
 */
export const techniqueColumns: ColumnDef<SearchableListItem>[] = [
  {
    id: 'category',
    accessorFn: row => row.category,
    header: 'Category',
    cell: ({ row }) => (
      <OverflowText
        className="text-chariot-text-secondary group-[.is-selected]:text-chariot-text-primary truncate"
        text={row.original.category ?? 'Unknown'}
      />
    ),
    size: 160,
    sortingFn: 'alphanumeric',
  },
  {
    id: 'name',
    accessorFn: row => row.name,
    header: 'TTP Name',
    cell: ({ row }) => (
      <NameCell name={row.original.name} metadata={row.original.metadata} />
    ),
    sortingFn: 'alphanumeric',
    meta: { flexible: true },
  },
];

/**
 * Default sort state: category ascending, then name ascending (alphabetical)
 */
export const techniqueDefaultSort: SortingState = [
  { id: 'category', desc: false },
  { id: 'name', desc: false },
];
